import {Box, Stack} from "@mui/material";
import React, {useCallback, useEffect} from "react";

import ContentIssuesWidget from "../contentIssues/ContentIssuesWidget";
import ContentQualityOverviewWidget from "./ContentQualityOverviewWidget";
import {getChapters} from "../../store/chapters/getChapters";
import selectCourseChaptersFetchStatus from "../../store/chapters/selectCourseChaptersFetchStatus";
import CourseFeature from "../../store/courses/CourseFeature";
import selectCourse from "../../store/courses/selectCourse";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {keyProvider} from "../../store/keyProvider";

function ContentQualityPage(props: {courseId: number}) {
	const {courseId} = props;

	const dispatch = useAppDispatch();

	const chaptersFetchStatus = useAppSelector((state) =>
		selectCourseChaptersFetchStatus(state, keyProvider.course(courseId))
	);

	const fetchChapters = useCallback(() => {
		dispatch(getChapters({courseId, opts: {noNotificationOnError: true}}));
	}, [courseId, dispatch]);

	const courseFeatures =
		useAppSelector(
			(state) => selectCourse(state, keyProvider.course(courseId))?.features
		) ?? [];

	const chaptersShouldBeFetched = chaptersFetchStatus === "none";

	useEffect(() => {
		if (chaptersShouldBeFetched) {
			fetchChapters();
		}
	}, [chaptersShouldBeFetched, fetchChapters]);

	const issueReportingEnabled = courseFeatures.includes(
		CourseFeature.IssueReporting
	);

	return (
		<Box
			sx={{
				padding: {md: 6, xs: 3},
				maxWidth: (theme) => theme.breakpoints.values.xl,
			}}
		>
			<Stack spacing={3}>
				<ContentQualityOverviewWidget
					courseId={courseId}
					onRefetchChapters={fetchChapters}
				/>

				{issueReportingEnabled && (
					<ContentIssuesWidget
						courseId={courseId}
						onRefetchChapters={() =>
							dispatch(
								getChapters({courseId, opts: {noNotificationOnError: true}})
							)
						}
					/>
				)}
			</Stack>
		</Box>
	);
}

export default ContentQualityPage;
